import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Layout, Space, Typography } from 'antd';
import type { MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { formatUserRole } from '@/constants/roles';
import { canManageTeam } from '@/constants/capabilities';
import * as authApi from '@/services/api/auth';
import { useAuthStore } from '@/stores/auth.store';

const { Header } = Layout;

export function AppHeader() {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const clearSession = useAuthStore((state) => state.clearSession);

  const handleLogout = async () => {
    try {
      await authApi.logout();
    } catch {
      // ignore logout API errors and clear local session anyway
    } finally {
      clearSession();
      navigate(ROUTES.login, { replace: true });
    }
  };

  const menuItems: MenuProps['items'] = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: () => {
        void handleLogout();
      },
    },
  ];

  return (
    <Header
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        background: '#fff',
        borderBottom: '1px solid #f0f0f0',
      }}
    >
      <Typography.Title level={4} style={{ margin: 0 }}>
        日报系统
      </Typography.Title>
      {user ? (
        <Dropdown menu={{ items: menuItems }} placement="bottomRight">
          <Space style={{ cursor: 'pointer' }}>
            <Avatar size="small" icon={<UserOutlined />} />
            <span>{user.name}</span>
            <Typography.Text type="secondary">
              {formatUserRole(user.role)}
              {canManageTeam(user) ? ' · 可管理团队' : ''}
            </Typography.Text>
          </Space>
        </Dropdown>
      ) : null}
    </Header>
  );
}
